// extracted by mini-css-extract-plugin
export var container = "_mz-0";